import React, { Component } from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import Modal from '../modal';

class Facet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };


        this.wrapperRef = React.createRef();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.props.addFacet(this);
        document.addEventListener('click', (e) => this.handleClickOutside(e));
    }

    close() {
        if (!this.state.isOpen) return;

        this.setState({
            isOpen: false
        });
    }

    handleClick() {
        this.props.closeAllFacets();

        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', (e) => this.handleClickOutside(e));
    }

    handleClickOutside(event) {    
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
           this.close();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isOpen !== prevState.isOpen) {
            this.props.checkIfAnyModalIsOpen();
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    render() {

        return (
            <div ref={this.wrapperRef} className={classNames({
                'filters__control': true,
                ...this.props.modifiers
            })}>
                <button type="button" 
                        className={classNames({
                            'filters__button': true,
                            'filters__button--is-expanded': this.state.isOpen
                        })}
                        onClick={() => this.handleClick()}>{this.props.text}</button>
                
                <Modal isOpen={this.state.isOpen} modifiers={this.props.modalModifiers}>
                    <>
                        <header className="filters__header">
                            <h1>{this.props.text}</h1>
                            <button onClick={() => this.close()} type="button" className="filters__modal-close"></button>
                        </header>
                        {React.cloneElement(this.props.children, { close: () => this.close(), ...this.props, ...this.state})}
                        <footer className="filters__footer">
                            <button type="button" className="filters__apply" onClick={() => {
                                //this.props.submitForm();
                                this.close();
                            }}>Tillämpa</button>
                        </footer> 
                    </>
                </Modal>
                
            </div>
        );    
    }
};

export default withRouter(Facet);